import React from 'react';
import { View } from 'react-native';

import { Button } from '../button/Button';
import Text from '../text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const PaginationNav = ({
	count,
	page,
	perPage,
	onPageChange,
}) => {
	const styles = useThemedStyles(createStyles);
	const numPages = Math.ceil(count / perPage);

	const pageAsNumber = parseInt(page, 10);

	return (
		<View style={styles.container}>
			{numPages > 0 && (
				<View style={styles.pageLabel}>
					<Text style={styles.pageText}>
						{ `Page ${pageAsNumber + 1} of ${numPages}` }
					</Text>
				</View>
			)}
			{pageAsNumber > 0 && (
				<Button
					style={styles.previousButton}
					onPress={() => onPageChange(pageAsNumber - 1)}
					label="Previous"
					flat={true}
				/>
			)}
			{pageAsNumber < numPages - 1 && (
				<Button
					onPress={() => onPageChange(parseInt(pageAsNumber, 10) + 1)}
					label="Next"
					flat={true}
				/>
			)}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		marginHorizontal: space.gutter,
		marginTop: space.sm,
		marginBottom: space.lg,
	},
	pageLabel: {
		marginRight: 'auto',
	},
	pageText: {
		...type.secondary,
		color: colors.textSecondary,
	},
	previousButton: {
		marginRight: space.sm,
	},
});

export default PaginationNav;
